export interface BeneficiaryDetails {
    userTitle:string;
    otherTitle:string;
    forename: string;
    surname: string;
    ukAddressIndicator:string;
    dateOfBirth: string;
    beneficiaryAllocPercentage:number;
    address : {
    postcode: string;
    addressline1: string;
    addressline2: string;
    addressline3: string;
    addressline4: string;
    countryCode:string
    }
    
   }